import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

const { $ } = window

export default {
	// About Slider Block

	init() {
		let sliderSections = document.querySelectorAll('.about-slides-container')
		// console.log(sliderSections)
		sliderSections.forEach((section, index) => {
			let slidesArr = Array.from(section.querySelectorAll('.about-slide')).map(
				(slide) => {
					return `#${slide.dataset.title.toLowerCase().replace(/ /g, '-')}`
				}
			)
			let wantedLocation = decodeURI(window.location.hash);
			//wantedLocation = wantedLocation.normalize('NFD').replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '');

			//console.log(decodeURI(wantedLocation));

			// console.log(wantedLocation)
			//console.log(slidesArr);
			let chosenSlide =
				slidesArr.indexOf(wantedLocation) >= 0
					? slidesArr.indexOf(wantedLocation)
					: 0
			if (!slidesArr.includes(wantedLocation)) {
				$(section)
					.find('.about-slides-wrap')
					.slick({
						adaptiveHeight: true,
						dots: true,
						slidesToShow: 1,
						autoplay: false,
						speed: 300,
						fade: true,
						cssEase: 'ease-out',
						initialSlide: 0,
						arrows: false,
						customPaging(slider, i) {
							let title = $(slider.$slides[i]).data('title')
							return title
						},
					})
			} else {
				$(section)
					.find('.about-slides-wrap')
					.slick({
						dots: true,
						slidesToShow: 1,
						autoplay: false,
						speed: 300,
						fade: true,
						cssEase: 'ease-out',
						arrows: false,
						initialSlide: chosenSlide,
						customPaging(slider, i) {
							let title = $(slider.$slides[i]).data('title')
							return title
						},
					})
					
					setTimeout(() => {
						section.scrollIntoView()
					}, 750)
				}
		})

		// create Toggle Button for mobile view and attach to slider
		const menus = document.querySelectorAll('.page-template-about .slick-dots')
		menus.forEach(function (el, idx) {
			let activeTab = el.querySelector('.slick-active')
			let button = document.createElement('button')
			let span = document.createElement('span')
			span.innerText = activeTab.innerText
			span.classList.add('slider-button-content')
			button.prepend(span)
			button.classList.add('slider-button')
			el.before(button)
		})

		// Button open and close menu functionality
		const toggleButtons = document.querySelectorAll('.slider-button')

		function removeOpen() {
			menus.forEach(function (el, idx) {
				if (el.classList.contains('open')) {
					// remove open from slick dots (menu window)
					el.classList.remove('open')
					// remove open from button
					toggleButtons[idx].classList.remove('open')
				}
			})
		}

		toggleButtons.forEach(function (el, idx) {
			el.addEventListener('click', function () {
				if (menus[idx].classList.contains('open')) {
					removeOpen()
				} else {
					menus[idx].classList.add('open')
					el.classList.add('open')
				}
			})
		})

		// Slide selector functionality
		const tabs = document.querySelectorAll('.slick-dots li')
		tabs.forEach(function (el) {
			el.addEventListener('click', function () {
				removeOpen()
				// Update button copy to current slide
				el.parentElement.previousElementSibling.childNodes[0].innerText =
					el.innerText
			})
		})

		// GSAP Animations

		let heroTL = gsap.timeline({
			defaults: {
				duration: 0.35,
				opacity: 0,
				stagger: 0.3,
				ease: 'power2.out',
			},
			onComplete() {
				// ScrollTrigger.create({
				// 	trigger: $('.hero-stats'),
				// 	start: 'center bottom',
				// 	onEnter: () => {
						// $('.stat-heading span').each(function () {
						// 	let $this = $(this),
						// 		countTo = $this.attr('data-count')

						// 	$({ countNum: $this.text() }).animate(
						// 		{
						// 			countNum: countTo,
						// 		},
						// 		{
						// 			duration: 1000,
						// 			easing: 'linear',
						// 			step() {
						// 				$this.text(Math.floor(this.countNum))
						// 			},
						// 			complete() {
						// 				$this.text(this.countNum)
						// 			},
						// 		}
						// 	)
						// })
				// 	},
				// })
			},
		})

		// Hero section
		gsap
			.timeline({
				defaults: {
					duration: 0.3,
					opacity: 0,
					stagger: 0.3,
					ease: 'power2.out',
				},
			})
			.from('.hero-img > .decor-img', {})
			.from('.hero-content', { x: 20 }, '-=0.25')
			.from('.hero-stats', {}, '-=0.25')
			.from('.hero-stat', { y: 8, stagger: 0.05 })

		// Cards
		gsap.from('.about-card', {
			scrollTrigger: {
				trigger: '.about-card',
				start: 'top 80%',
			},
			y: -20,
			opacity: 0,
			stagger: 0.3,
			ease: 'power2.out',
		})

		// Slider Section
		let sliders = gsap.utils.toArray('.about-slides-container')
		let headers = gsap.utils.toArray('.slick-dots')

		sliders.forEach((slider) => {
			let preHeading = slider.querySelector('.pre-heading')
			let heading = slider.querySelector('.heading-content h2')
			let content = slider.querySelectorAll('.about-slide-content')
			let image = slider.querySelectorAll('.about-slide-img')
			let btn = slider.querySelector('.slider-button')

			gsap
				.timeline({
					scrollTrigger: {
						trigger: slider,
						// scrub: 2,
						start: 'top 90%',
						end: '+=30%',
						toggleActions: 'play none none none',
					},
					defaults: { opacity: 0, ease: 'power2.out' },
				})

				.from(preHeading, {
					xPercent: 5,
				})

				.from(heading, {
					xPercent: -5,
				})

				.from(btn, {})

			gsap
				.timeline({
					scrollTrigger: {
						trigger: content,
						// scrub: 2,
						start: 'top 90%',
						end: '+=30%',
						toggleActions: 'play none none none',
					},
					defaults: { opacity: 0, ease: 'power2.out' },
				})

				.from(content, {
					y: -20,
				})

				.from(image, {
					scale: 0.8,
				})
		})

		headers.forEach((header) => {
			let tab = header.querySelectorAll('li')

			gsap.from(tab, {
				scrollTrigger: {
					trigger: tab,
					start: 'top 90%',
					toggleActions: 'play none none none',
				},
				opacity: 0,
				stagger: 0.1,
				duration: 0.3,
				// y: 20,
			})
		})

		// CTA Section
		// gsap
		// 	.timeline({
		// 		scrollTrigger: {
		// 			trigger: '.page-template-about .call-to-action',
		// 			start: 'top 90%',
		// 		},
		// 		defaults: {
		// 			opacity: 0,
		// 			duration: 0.5,
		// 		},
		// 	})

		// 	.from('.page-template-about .call-to-action', {
		// 		scale: 0,
		// 		transformOrigin: '70% 0',
		// 	})
		// 	.from('.page-template-about .call-to-action h3', { x: 20 })
		// 	.from('.page-template-about .call-to-action p', { x: 20 })
		// 	.from('.page-template-about .call-to-action a', { y: -20 })

		animateAboutSagard()
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS

		//parallax on home/about hero
		document.querySelector('.hero-stats').classList.add('parallax')
		// eslint-disable-next-line no-undef
		const instance = basicScroll.create({
			elem: document.querySelector('.hero-stats'),
			from: 'top-bottom',
			to: 'bottom-top',
			props: {
				'--heroStats': {
					from: '32px',
					to: '-100px',
				},
			},
		})

		instance.start()
	},
}

function animateAboutSagard() {
	if (!$('.about-sagard').length) {
		return
	}
	const tl = gsap.timeline({
		scrollTrigger: { trigger: '.about-sagard', start: 'center bottom' }, //, toggleAction: 'play none none reverse' },
		defaults: { duration: 0.35, opacity: 0 },
	})

	// gsap.set('.about-sagard h2', {opacity: 0})
	// gsap.set('.about-sagard p', {opacity: 0})
	// gsap.set('.about-sagard .btn', {opacity: 0})
	tl.from('.about-sagard h2', { x: -32, ease: 'power1.out' })
	tl.from('.about-sagard p', { y: 16, ease: 'power1.out' }, '-=0.25')
	tl.from('.about-sagard .btn', { y: 32, duration: 0.1 }, '-=0.2')
}

// function handleLoadSliderSection() {
// 	let selectedSection = window.location.href.split('#')
// 	let selectedValue = selectedSection[1]
// 	let availSections = document.querySelectorAll('.about-slide')
// 	let availArr = Array.from(availSections).map((slide) => {
// 		return slide.dataset.title.toLowerCase().replace(/ /g, '-')
// 	})
// 	let containers = document.querySelectorAll('.about-slides-container')
// 	return containers[0] ? availArr.indexOf(selectedValue) : 0
// }
